/**
 * Extrae codigo público y token de una URL de verificación QR.
 * Soporta URLs con hash (#/v/...) o path directo.
 */
export function parseCredencialQrUrl(url) {
    if (!url) return null;
    const match = String(url).match(/\/v\/([^/?#]+)\/([A-Za-z0-9]+)/);
    if (!match) return null;
    return { codigoPublico: match[1], token: match[2] };
}

/** URL de verificación pública para el QR (HashRouter). */
export function buildVerificacionUrl(codigoPublico, token) {
    const { origin, pathname } = window.location;
    const basePath = pathname && pathname !== '/' ? pathname : '';
    return `${origin}${basePath}#/v/${codigoPublico}/${token}`;
}
